exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orders-table .action-bar{position:sticky;top:0;z-index:10}", ""]);

// exports
